/**관할 법원 */
import styled from 'styled-components';
import React, { useMemo, useState, useEffect } from 'react';
import CourtMap from './CourtMap';
import DisclaimerSection from '../DisclaimerSection';
import { useNavigate } from 'react-router-dom';
import { useReportContext } from '../../../../context/DetailContext';
import LoanInfoService from '../../../../service/LoanInfo';
// 주소 구분 함수

interface CourtInfoProps {
  court: string;
  address: string;
  belong: string;
  lat: number;
  lng: number;
}

interface Props {
  courtInfo: CourtInfoProps;
  linkSet: any;
  caseInfo: any;
}
const JurisdictionCourt = ({ courtInfo, linkSet, caseInfo }: Props) => {
  const { type } = useReportContext();
  const [itemDetailButtonOn, setItemDetailButtonOn] = useState<boolean>(false);
  const [casDetailButtonOn, setCasDetailButtonOn] = useState<boolean>(false);
  const [dateDetailButtonOn, setDateDetailButtonOn] = useState<boolean>(false);
  const [deliveryButtonOn, setDeliveryButtonOn] = useState<boolean>(false);
  const iidx = caseInfo?.iidx;
  const courtLinks = [
    {
      title: '물건상세',
      path: `/itemDetail?iidx=${iidx}`,
      disabled: !itemDetailButtonOn,
    },
    {
      title: '사건내역',
      path: `/incidentDetail?iidx=${iidx}`,
      disabled: !casDetailButtonOn,
    },
    {
      title: '기일내역',
      path: `/dateDetail?iidx=${iidx}`,
      disabled: !dateDetailButtonOn,
    },
    {
      title: '문건/송달내역',
      path: `/documentDetail?iidx=${iidx}`,
      disabled: !deliveryButtonOn,
    },
  ];

  const handleCopyAddress = () => {
    navigator.clipboard
      .writeText(courtInfo.address)
      .then(() => {
        alert('주소가 복사되었습니다!');
      })
      .catch((err) => {
        console.error('주소 복사에 실패했습니다:', err);
        alert('주소 복사에 실패했습니다.');
      });
  };
  const hasItemDetail = itemDetailButtonOn === true;
  // API 호출: 상세 버튼 상태
  useEffect(() => {
    if (type === 's') return;
    if (iidx) {
      getDetailButtonStates(iidx);
    }
  }, [type, iidx]);

  const getDetailButtonStates = async (iidx: number) => {
    try {
      const res = await LoanInfoService.courtDetail(iidx);
      if (res.data.item_detail?.basic_info?.case_no != null) {
        setItemDetailButtonOn(true);
      }
      if (res.data.case_detail?.basic_info?.case_no != null) {
        setCasDetailButtonOn(true);
      }
      if (res.data.date_list != null) {
        setDateDetailButtonOn(true);
      }
    } catch (e) {
      console.error(e);
    }
  };

  // API 호출: 현황조사서 / 문건송달
  useEffect(() => {
    if (iidx) {
      getDeliveryData(iidx);
    }
  }, [iidx]);

  const getDeliveryData = async (iidx: number) => {
    try {
      const res = await LoanInfoService.documentDelivery(iidx);
      const hasData =
        res.data?.date_list?.length > 0 && res.data?.date_list2?.length > 0;
      setDeliveryButtonOn(hasData);
    } catch (e) {
      console.error(e);
      setDeliveryButtonOn(false);
    }
  };

  return (
    <DetailContainer id="관할법원">
      <TitleBox>관할법원</TitleBox>
      <CourtMap courtInfo={courtInfo} />
      <ContentWrapper>
        <CourtInfoBox>
          <CourtName>{courtInfo.court}</CourtName>
          <div>{courtInfo.belong}</div>
          {/* <div>집행관사무소: 02-1234-1234</div> */}
        </CourtInfoBox>
        <AddressBox>
          <div>{courtInfo.address}</div>
          <CopyAddress onClick={handleCopyAddress}>
            <img src="/assets/images/icon/copy-blue.svg" alt="" />
            주소복사
          </CopyAddress>
        </AddressBox>
      </ContentWrapper>
      <CourtAuctionContainer>
        {courtLinks.map((item, idx) => (
          <CourtAuctionBox
            key={idx}
            onClick={() => {
              if (item.disabled) return;
              window.open(item.path, '_blank');
            }}
            style={{
              opacity: item.disabled ? 0.2 : 1,
              pointerEvents: item.disabled ? 'none' : 'auto',
              cursor: item.disabled ? 'not-allowed' : 'pointer',
            }}
          >
            {item.title}
            <img src="/assets/images/icon/open-in-new.svg" alt="이동하기" />
          </CourtAuctionBox>
        ))}
      </CourtAuctionContainer>
      {/* <DisclaimerSection /> */}
    </DetailContainer>
  );
};
export default JurisdictionCourt;

const DetailContainer = styled.div`
  width: 100%;
  height: fit-content;
  padding: 24px 16px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const TitleBox = styled.span`
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 700;
  line-height: 26.1x;
  letter-spacing: -0.8px;
  width: 100%;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 8px;
`;

const CourtInfoBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;

  color: #37383c9c;
  font-size: 12px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
`;

const CourtName = styled.div`
  color: #222;
  font-size: 14px;
  font-weight: 500;
`;

const AddressBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  align-items: start;

  font-size: 12px;
  color: #616161;
  font-weight: 500;
`;

const CopyAddress = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 2px;
  font-weight: 500;
  font-size: 12px;
  color: #008aff;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
`;

const CourtAuctionContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const CourtAuctionBox = styled.div`
  width: fit-content;
  background-color: #0220470d;
  padding: 10px 8px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: 2px;
  align-items: center;
  white-space: nowrap;

  font-weight: 500;
  font-size: 12px;
  color: #000c1ecc;
`;
